// 获取用户信息
export const USER_INFO = 'USER_INFO';

// 获取用户设置
export const USER_SETTINGS = 'USER_SETTINGS';

// 获取用户设置
export const SAVE_USER_SETTING = 'SAVE_USER_SETTING';

// 查询邮箱
export const SEARCH_EMAIL_USER = 'SEARCH_EMAIL_USER';

// 查询参与人
export const SEARCH_EVENT_USER = 'SEARCH_EVENT_USER';
